import { render, staticRenderFns } from "./GovernmentHolidays.vue?vue&type=template&id=d16e4a1e"
import script from "./GovernmentHolidays.vue?vue&type=script&lang=js"
export * from "./GovernmentHolidays.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports